<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import OnboardingGroupeComponent from './components/OnboardingGroupeComponent.vue';
    import router from '@/router';
    import { useRoute } from 'vue-router';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';

    const route = useRoute();
    const collectivite = ref(null as any);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);

    onMounted(() => {
        const form_datas = route.meta.form_datas as { collectivite: any };
        collectivite.value = form_datas.collectivite;
    });

    async function onOnboardingCompleted(onboardingResponse: { has_prelevements: boolean, collectivite_id: number }) {
        let confirmation = false;
        if (onboardingResponse.has_prelevements == false) {
            confirmation = await confirmationModalRef.value!.open("Onboarding", `Les membres de la collectivité ${collectivite.value?.nom} ont été importés avec succès. Voulez-vous procéder au premier prélèvement ?`);
        }

        if (confirmation) {
            router.push('/app/finance/prelevements/' + onboardingResponse.collectivite_id);
        } else {
            router.push('/app/users/list?sort=created_at_desc');
        }
    }

</script>

<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-30"></div>
        <div v-if="collectivite">
            <onboarding-groupe-component :collectivite="collectivite" @completed="onOnboardingCompleted" />
        </div>
        <confirmation-modal ref="confirmationModalRef"></confirmation-modal>
    </section>
</template>
